/**
 * @generated SignedSource<<48f241f5301ddb548f8ba9522a8f1272>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type atomsCurrentArticleAtomBase$data = {
  readonly __typename: "Article";
  readonly " $fragmentSpreads": FragmentRefs<"abandonedCartOfferDialogArticle" | "articleHeadlineHeaderFeaturesArticle" | "articleSeoArticle" | "articleShareWidgetArticle" | "bookmarkHeaderFeaturesArticle" | "commentHeaderFeaturesArticle" | "contentShareWidgetContent" | "entityLinkHeaderFeaturesArticle" | "helpersCheckIsStyleArticle" | "helpersUseSharingUrl" | "hooksContentInterestArticle" | "hooksTrackPageViewArticle" | "hooksUseCurrentArticleIdsArticle" | "hooksUseCurrentArticlePrebidConfigArticle" | "hooksUsePageTargetingArticle" | "onboardingNewsletterSubscriptionArticle" | "shareHeaderFeaturesContent">;
  readonly " $fragmentType": "atomsCurrentArticleAtomBase";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "atomsCurrentArticleAtomBase";
};
export type atomsCurrentArticleAtomBase$key = {
  readonly " $data"?: atomsCurrentArticleAtomBase$data;
  readonly " $fragmentSpreads": FragmentRefs<"atomsCurrentArticleAtomBase">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "atomsCurrentArticleAtomBase"
};

(node as any).hash = "3008f4dfa9243710f5b5b3fac91d7441";

export default node;
